// @ts-nocheck

import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import styled from 'styled-components';
import v4 from 'uuid';

import ScrollingLabelsContext from '../contexts/ScrollingLabelsContext';

const FPS = 1000 / 60;

const Wrap = styled.p`
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
  line-height: 1.2;
`;

const Text = styled.span`
  text-align: left;
  display: block;
`;

const setScrollingX = (item, x) => {
  item.style.webkitTransform = `translateX(-${x}px)`;
  item.style.MozTransform = `translateX(-${x}px)`;
  item.style.transform = `translateX(-${x}px)`;
};

const ScrollingLabel = (props) => {
  const { label, className } = props;
  const { start, sayConsumerScrollingIsFinish, pauseDuration, register, dispose } = useContext(ScrollingLabelsContext);
  const [distanceToScroll, setDistanceToScroll] = useState(null);
  const wrapRef = useRef(null);
  const textRef = useRef(null);
  const frame = useRef(null);
  const timeout = useRef(null);
  const positionX = useRef(null);
  const hasFinishScroll = useRef(false);
  const lastTime = useRef(Date.now());
  const id = useRef(v4());

  // animation
  const scrolling = useCallback(() => {
    if (textRef.current) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - lastTime.current;
      if (elapsedTime > FPS) {
        if (positionX.current < distanceToScroll) {
          positionX.current++;
          setScrollingX(textRef.current, positionX.current);
        } else {
          hasFinishScroll.current = true;
          timeout.current = setTimeout(() => {
            sayConsumerScrollingIsFinish(id.current);
            positionX.current = 0;
            setScrollingX(textRef.current, positionX.current);
          }, pauseDuration);
        }
        lastTime.current = currentTime;
      }
    }
    if (!hasFinishScroll.current) {
      frame.current = requestAnimationFrame(scrolling);
    }
  }, [distanceToScroll, pauseDuration, sayConsumerScrollingIsFinish]);

  // start animation if distance to scroll change
  useEffect(() => {
    if (start && distanceToScroll > 0) {
      frame.current = requestAnimationFrame(scrolling);
      hasFinishScroll.current = false;
      lastTime.current = Date.now();
      positionX.current = 0;
      setScrollingX(textRef.current, positionX.current);

      return () => {
        cancelAnimationFrame(frame.current);
        clearTimeout(timeout.current);
      };
    }
  }, [distanceToScroll, scrolling, start]);

  // compute distance to scroll
  useEffect(() => {
    const availableWidth = wrapRef.current.offsetWidth;
    const scrollWidth = wrapRef.current.scrollWidth;
    setDistanceToScroll(scrollWidth - availableWidth);
  }, [label]);

  // detect if label should be concern by animation
  useEffect(() => {
    if (distanceToScroll !== null) {
      if (distanceToScroll > 0) {
        register(id.current);
      } else {
        dispose(id.current);
      }
    }
  }, [register, dispose, distanceToScroll]);

  // dispose when unmount
  useEffect(() => {
    const labelId = id.current;
    return () => {
      dispose(labelId);
    };
  }, [dispose]);

  return (
    <Wrap ref={wrapRef} className={className}>
      <Text ref={textRef}>{label}</Text>
    </Wrap>
  );
};

export default ScrollingLabel;
